import script from "./AcpToasts.vue?vue&type=script&setup=true&lang=js"
export * from "./AcpToasts.vue?vue&type=script&setup=true&lang=js"

import "./AcpToasts.vue?vue&type=style&index=0&id=3b420e4a&lang=css"

const __exports__ = script;

export default __exports__